import { Navigate, Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";
import AdminLayout from "../../layouts/AdminLayout";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminProtectedRoute() {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    checkAdmin();
  }, []);

  const checkAdmin = async () => {
    try {
      const res = await fetch(`${API}/api/auth/me`, { credentials: 'include' });
      if (res.ok) {
        const user = await res.json();
        if (user.role === 'super_admin' || user.role === 'admin_employee') {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    } catch (e) {
      setIsAdmin(false);
    }
  };

  if (isAdmin === null) {
    return (
      <div className="h-screen flex items-center justify-center bg-zinc-950 text-white">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-500" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/admin/auth" replace />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
